var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"wrapper table-wrapper pa-0 ma-0"},[_c('iframe',{staticClass:"ticket-report-frame",attrs:{"id":"tickets-dash-frame","data-tickets-dash":"","src":"https://src.abriron.net/tickets-dash/","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }